export default defineNuxtRouteMiddleware((to, from) => {
  if (typeof to.path === 'string' && (to.path.includes('http://') || to.path.includes('https://'))) {
    if (import.meta.client) {
      const router = useRouter()
      router.replace(from.fullPath || '/')

      return abortNavigation()
    }

    return navigateTo('/')
  }
})
